import './App.css';
import { useContext, useEffect, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import Home from './container/Home';
import About from './container/About'
import Contact from './container/Contact';
import Navbar from './components/Navbar';
// import Project from './container/Project';
import Experience from './container/Experience';
import { Element } from 'react-scroll';
import Skills from './container/Skills';
import CustomCursor from './Helper/CustomCursor';
import { ThemeContext } from './context/ThemeContext';

const Project = lazy(() => import('./container/Project'));

function App() {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className="App overflow-x-hidden ">
      <CustomCursor />
      <Navbar />
      <SectionWatcher />
      <Element name="home" id="home" className="section">
        <Home />
      </Element>
      <Element name="about" id="about" className="section">
        <About />
      </Element>
      <Element name="skills" id="skill" className="section">
        <Skills />
      </Element>
      <Element name="experience" id="experience" className="section">
        <Experience />
      </Element>
      <Element name="projects" id="projects" className="section">
        <Suspense fallback={<div className='min-h-[400px] flex justify-center items-center text-2xl font-bold text-gray-500'>Loading Projects...</div>}>
          <Project />
        </Suspense>
      </Element>
      <Element name="contact" id="contact" className="section">
        <Contact />
      </Element>
    </div>
  );
}

const SectionWatcher = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const sections = document.querySelectorAll('.section')
    const options = {
      root: null,
      threshold: 0.5, // 50% visibility triggers the observer
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          navigate(`/${sectionId}`);
        }
      });
    }, options);

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };

  }, [navigate])

  return null;
}

export default App;